// antd
import { Modal } from 'antd'

// components
import ModelHeader from './modelHeader'
import ModalFooter from './modalFooter'

function ModalComponent({
    visibility,
    handleCancel,
    content,
    modalTitle,
    showTitle,
    selectedDataMaster,
    icon,
    masterDataState,
    buttonName,
    selectedDataProfile,
    minWidth = "790px"
}) {
    return (
        <>
            <Modal
                className="profileModal"
                open={visibility}
                title={
                    <ModelHeader
                        selectedDataMaster={selectedDataMaster}
                        modalTitle={modalTitle}
                        showTitle={showTitle}
                        handleCancel={handleCancel}
                        selectedDataProfile={selectedDataProfile}
                        icon={icon}
                    />
                }
                onCancel={handleCancel}
                destroyOnClose={true}
                // closeIcon={<></>}
                cancelButtonProps={{
                    hidden: true,
                }}
                footer={
                    <ModalFooter
                        buttonName={buttonName}
                        selectedState={masterDataState}
                    />
                }
                closable={true}
                centered
                style={{
                    minWidth: minWidth,
                    overflowY: 'hidden',
                    padding: 0,
                    borderRadius: '8px',
                }}
                styles={{
                    body: {
                        // old Padding
                        // padding: '25px 50px', 
                        padding: '10px 24px 0px 24px',
                    },
                }}
            >
                <div
                    style={{
                        overflowY: 'auto',
                        maxHeight: '60vh',
                    }}
                >
                    {content}
                </div>
            </Modal>
        </>
    )
}
export default ModalComponent
